import { render } from "./ArtWorkSearch.vue?vue&type=template&id=54178041&scoped=true&ts=true"
import script from "./ArtWorkSearch.vue?vue&type=script&lang=ts"
export * from "./ArtWorkSearch.vue?vue&type=script&lang=ts"

import "./ArtWorkSearch.vue?vue&type=style&index=0&id=54178041&scoped=true&lang=scss"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54178041"]])

export default __exports__